import React from 'react'

const style = {
  textAlign: 'center' as const,
  paddingTop: '20px',
  paddingBottom: '20px'
}

function LearnMoreFooter({ link, text }) {
  return (
    <div>
      <p style={style}>
        Learn more about <a href={link}>{text}</a>
      </p>
    </div>
  )
}

export { LearnMoreFooter }
